<template>
    <section
        class="modal-section"
        v-modal-accessibility="{ isOpen: isOpenedUnsubscribePopup, onClose: closeModalUnsubscribe }"
    >
        <div class="disp-modal unsubscribe-modal-display cross-absolute" id="unsubscribe_modal">
            <div class="container">
                <div class="unsubscribe-modal">
                    <div class="modal-overlay" @click="closeModalUnsubscribe"></div>
                    <div class="modal-content-wrap unsubscribe-modal_wrap unsubscribe_m">
                        <div class="a-q-m_close" @click="closeModalUnsubscribe"></div>
                        <div class="unsubscribe_m_body">
                            <h4 class="header">{{ $t('subscriptionUnsubscribeModalTitle') }}</h4>
                            <p class="description">{{ $t('subscriptionUnsubscribeModalDescription') }}</p>
                            <div class="unsubscribe_m_inputs">
                                <input type="button" @click="closeModalUnsubscribe" class="btn-default-white" :value="$t('cancelAllAction')">
                                <input type="button" @click="cancelSubscriptions(unsubscribeTarifData.ids)" class="btn-default-blue" :disabled="isCancelling" :value="$t('confirmAllAction')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import gql from "@/services/gql"
import { cancelSubscriptionsByIds } from "@/services/tariffs/subscriptionCancel.service"

const CANCEL_SUBSCRIPTION_MUTATION = `
    mutation UserCancelSubscription($subscriptionId: ID) {
        userCancelSubscription(subscription_id: $subscriptionId)
    }
`

export default {
    props: {
        isOpenedUnsubscribePopup: {
            type: Boolean,
            default: false,
        },
        unsubscribeTarifData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isCancelling: false,
        }
    },
    methods: {
        closeModalUnsubscribe() {
            // Keep the modal (and its disabled Confirm) up until every request has settled.
            if (this.isCancelling) {
                return
            }
            this.$emit("togle-unsubscribe-popup");
        },
        async cancelSubscriptions(ids) {
            if (this.isCancelling || !Array.isArray(ids) || !ids.length) {
                return
            }
            this.isCancelling = true
            let result
            try {
                result = await cancelSubscriptionsByIds(ids, async (id) => {
                    const data = await gql.request({
                        query: CANCEL_SUBSCRIPTION_MUTATION,
                        variables: { subscriptionId: id },
                    })
                    return data?.userCancelSubscription
                })
            } finally {
                this.isCancelling = false
            }
            result.failed.forEach(({ id, error }) => console.log('Subscription cancel failed:', id, error))
            this.closeModalUnsubscribe()
            this.$emit("complete-cancel-subscription", result);
            const authFailure = result.failed.find(({ error }) => error?.status == 401 || error?.status == 419)
            if (authFailure) {
                this.errorAuth(authFailure.error.status)
            }
        },
    },
}
</script>

<style scoped>
.unsubscribe-modal {
    height: 100%;
    display: flex;
    align-items: flex-start;
    margin-top: 20%;
    justify-content: center;
}
.unsubscribe-modal_wrap {
    width: 95%;
    max-width: 396px;
    padding: 24px;
    background-color: var(--color-main-white);
    border-radius: 16px;
}
.unsubscribe_m_body {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.unsubscribe_m_inputs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    margin-top: 16px;
}
/* .unsubscribe_m_inputs input {
    width: auto;
} */
</style>
